import React from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import PlatformUsers from "./PlatformUsers"
import PlatformDevices from "./PlatformDevices"
import PlatformPermissions from "./PlatformPermissions"
import PlatformAPIKeys from "./PlatformAPIKeys"

const PlatformAccessHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminPlatformAccess"
      tabs={{
        users: PlatformUsers,
        devices: PlatformDevices,
        permissions: PlatformPermissions,
        "api-keys": PlatformAPIKeys,
      }}
    />
  )
}

export default PlatformAccessHome